import React from "react";
import { RotaButton } from "@teamrota/rota-design";

import { Action, Actions, Dialog, Heading, Message, Overlay } from "./styles";

export const ResultModal: React.FC<{
  message: string;
  isError: boolean;
  onDismiss: () => void;
}> = ({ message, isError, onDismiss }) => {
  return (
    <Overlay onClick={onDismiss}>
      <Dialog
        role="dialog"
        aria-modal="true"
        aria-label="Action result"
        onClick={(event) => event.stopPropagation()}
      >
        <Heading>{isError ? "Error" : "Success"}</Heading>

        <Message>{message}</Message>

        <Actions>
          <Action>
            <RotaButton onClick={onDismiss} size="large" variant="contained">
              OK
            </RotaButton>
          </Action>
        </Actions>
      </Dialog>
    </Overlay>
  );
};
